export const importComposeBox = () => import(
  '../../_components/compose/ComposeBox.html'
).then(mod => mod.default)
